import { render, staticRenderFns } from "./AS_SmartPrepaidBalance.vue?vue&type=template&id=458f867e&scoped=true&"
import script from "./AS_SmartPrepaidBalance.vue?vue&type=script&lang=js&"
export * from "./AS_SmartPrepaidBalance.vue?vue&type=script&lang=js&"
import style0 from "./AS_SmartPrepaidBalance.vue?vue&type=style&index=0&id=458f867e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f867e",
  null
  
)

export default component.exports